import React, { Fragment, useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
// import api from '../../../../api';
import '../../../../src/styles/grid.scss';
import { Customer, getInvalidCustomerFieldsEnquiry, IActivityListingDetails, ILeadActivity, ILeadEvent, IUpdateEventModel, useMasterData } from '../../../core';
import { useAppSettings } from '../../../core/hooks/useAppSettings';
import api from '../../../api';
import { useLeadActivities } from '../../../core/hooks/useLeadActivities';
import { ActivityModel } from '../../leads/components/activities/add-activity';
import { ContainerLoader } from '../../../components/loader';
import { ActivityItemBuilder } from '../../leads/components/activities/activity-item-builder';
import { EditEventPopup } from '../../leads/components/activities/edit-event-popup';
import CustomerEdit from '../../customer/components/customer-stage-edit/CustomerEdit';
import { ActivityCategory } from '../../requirement/components/props';

interface IPlannedActivityProps {
  addActivity?: () => void;
  activityDetails?: IActivityListingDetails;
  leadIds?: string[];
  customer?: Customer;
  onUpdateCustomer?: (id: string) => void;
  onReload?: () => void;
  activityCategoryId?: string;
  activityCategory?: string;
}

export const PlannedActivities: React.FunctionComponent<IPlannedActivityProps> = (
  props
) => {
  const masterData = useMasterData(api.settings);
  const appSettings = useAppSettings(api.settings);
  const activities = props.activityDetails?.data ?? [];
  const {
    leadState,
    updateActivity,
    getEventDetails,
    createEventUpdateFormData,
    getAllLeadActivities,
    getLeadActivitiesAll,
    activityMarkAsDone,
  } = useLeadActivities(api.lead);

  const [currentActivity, setCurrentActivity] = useState<ActivityModel>();
  const [isEditing, setIsEditing] = useState(false);

  const [customerModal, setCustomerModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
  }>({});

  useEffect(() => {
    if (!isEditing) {
      setCurrentActivity(undefined);
    }
  }, [isEditing]);
  const onPressEdit = async (activity: ILeadActivity) => {

    if (activity.event != null) {
      getEventDetails(activity?.event?._id, (eventDetails: ILeadEvent) => {
        const activityModel: ActivityModel = createEventUpdateFormData(
          eventDetails
        );
        setCurrentActivity(activityModel);
        setIsEditing(true);
      });
    } else {
      toastr.error('Error', 'Event is null');
    }
  };

  const onSubmitActivity = (apiModel: IUpdateEventModel) => {
    // console.log('called submit')
    const forAll = props.leadIds && props.leadIds?.length > 0 ? true : false;
    updateActivity(currentActivity?.eventId!, apiModel, () => {
      if (props.activityCategoryId) {
        getLeadActivitiesAll([props.activityCategoryId], props.activityCategory);
      } else if (props.leadIds && props.leadIds?.length) {
        getLeadActivitiesAll(props.leadIds);
      } else {
        getAllLeadActivities(apiModel.leadId!);
      }
      setIsEditing(false);
    });
  };
  if (activities.length === 0 && !(props.activityDetails?.isLoading ?? false)) {
    return (
      <li className="text-center mb-4 pb-2 position-relative ">
        <span className="bg-gray-300 rounded-pill px-2 font-xxs text-uppercase">
          No Planned activities!
        </span>
      </li>
    );
  }

  return (
    <Fragment>
      <li className="text-center mb-4 pb-2 position-relative ">
        <span className="bg-gray-300 rounded-pill px-2 font-xxs text-uppercase">
          Planned
        </span>
      </li>
      <div className="mb-3">
        {props.activityDetails?.isLoading && (
          <ContainerLoader></ContainerLoader>
        )}
        {activities.map((p, index) => {
          return (
            <div key={'planned-activities-' + index}>
              {ActivityItemBuilder.builder[p.type] != null &&
                ActivityItemBuilder.builder[p.type](
                  p,
                  props.leadIds,
                  () => {
                    onPressEdit(p);
                  },
                  props.customer,
                  (id: string) => {
                    setCustomerModal({ isOpen: true, id });
                  },
                  () => {
                    props.onReload?.();
                  },
                  undefined,
                  () => {
                    props.addActivity?.();
                  },
                  props?.activityCategoryId,
                  props.activityCategory
                )}
            </div>
          );
        })}
      </div>
      {isEditing && currentActivity !== undefined && (
        <EditEventPopup
        activityCategory={props.activityCategory}
        activityCategoryId={props.activityCategoryId}
          isEdit={true}
          currentActivity={currentActivity}
          onClose={() => {
            setIsEditing(false);
          }}
          onSubmit={(updatedEvent) => {
            onSubmitActivity(updatedEvent);
          }}
          leadId={leadState?.leadDetails?._id!}
          companyId={props.activityCategoryId}
        ></EditEventPopup>
      )}
      {customerModal?.isOpen && (
        <>
          <CustomerEdit
            onClose={() => setCustomerModal({})}
            id={props?.customer?._id || ''}
            onReload={async () => {
              const customerData = await api.customer.getDetails(
                props?.customer?._id!
              );

              const invalidCustomerFieldsForEnquiry = customerData
                ? getInvalidCustomerFieldsEnquiry(
                  customerData,
                  masterData?.data?.leadStages
                    ?.find((x) => x.code === 'enquiry')
                    ?.entity?.find((c) => c.key === 'Customer')!
                )
                : [];

              if (!invalidCustomerFieldsForEnquiry?.length) {
                activityMarkAsDone(
                  leadState?.leadDetails?._id ?? '',
                  customerModal?.id ?? '',
                  () => {
                    // console.log('called in')
                    if (props.activityCategoryId) {
                      getLeadActivitiesAll([props.activityCategoryId], 'company');
                    } else if (props.leadIds?.length) {
                      getLeadActivitiesAll(props.leadIds || []);
                    } else {
                      getAllLeadActivities(leadState?.leadDetails?._id || '');
                    }
                    props.onReload?.();
                    setCustomerModal({});
                  }
                );
              } else {
                props.onReload?.();
                setCustomerModal({});
              }
            }}
            entity={
              masterData?.data?.leadStages?.find((x) => x.code === 'enquiry')
                ?.entity!
            }
            leadDetails={leadState.leadDetails}
          />
        </>
      )}
    </Fragment>
  );
};
